export default {
    skillCenter: {
        title: '技能中心',
        searchPlaceholder: '搜尋技能...',
        createSkill: '建立技能',
        aiCreate: 'AI 建立',
        noSkills: '暫無技能',
        noSkillsDesc: '點擊「建立技能」按鈕新增您的第一個技能',
        preview: '預覽',
        edit: '編輯',
        aiEdit: 'AI 編輯',
        delete: '刪除',
        cancel: '取消',
        save: '儲存',
        close: '關閉',
        moreActions: '更多操作',
        official: '官方',
        custom: '自訂',
        enabled: '已啟用',
        disabled: '已停用',
        enable: '啟用',
        disable: '停用',
        version: '版本',

        viewModes: {
            grid: '網格視圖',
            list: '清單視圖',
        },

        pills: {
            official: '官方技能',
            user: '我的技能',
        },

        dialog: {
            createTitle: '建立技能',
            editTitle: '編輯技能',
            previewTitle: '技能詳情',
            name: '技能名稱',
            namePlaceholder: '請輸入技能名稱（建立後不可修改）',
            description: '描述',
            descriptionPlaceholder: '請輸入描述資訊（可選）',
            tags: '標籤',
            tagsPlaceholder: '輸入後按 Enter 新增',
            tagsReadonlyHint: '標籤僅建立時可設定',
            editingFile: '正在編輯：{path}',
            binaryFileHint: '二進位檔案不支援線上編輯',
            unsavedChangesTitle: '未儲存的修改',
            unsavedChangesMessage: '您有未儲存的修改，確定要關閉嗎？關閉後修改將遺失。',
            discardChanges: '放棄修改',
            continueEditing: '繼續編輯',
        },

        workspace: {
            title: 'AI 工作台',
            backToList: '返回技能列表',
            loadingTitle: '載入中…',
            chatUnavailableTitle: 'AI 對話暫不可用',
            chatUnavailableDesc: 'Skill 工作區初始化失敗或後端服務未就緒，可稍後從技能列表重新進入。',
            toolResultTitle: '工具結果',
            saving: '儲存中…',
        },

        fileTree: {
            newFile: '新建檔案',
            fileName: '檔案名稱',
            fileNamePlaceholder: '例如 api.md、run.py（請包含副檔名）',
            fileNameInvalid: '檔案名稱不能包含 /',
            newDirectory: '新建目錄',
            directoryName: '目錄名稱',
            parentPath: '父目錄',
            rootPath: '（根目錄）',
            rename: '重新命名',
            newName: '新名稱',
            skillMdProtectedHint: 'SKILL.md 不支援重新命名或刪除',
        },

        security: {
            violationsTitle: '內容安全審查未通過',
            blockedHint: '請根據以下違規項修改內容後重新儲存',
            ruleId: '規則',
        },

        messages: {
            fetchListFailed: '取得技能列表失敗',
            fetchDetailFailed: '取得技能詳情失敗',
            fetchFileFailed: '取得檔案內容失敗',
            createSuccess: '建立成功',
            createFailed: '建立失敗',
            nameExists: '技能名稱已存在，請修改後重試',
            updateSuccess: '更新成功',
            updateFailed: '更新失敗',
            metadataSavedFilesNotSaved: '技能資訊已儲存，但部分檔案未儲存成功，請檢查違規內容後重試',
            deleteSuccess: '刪除成功',
            deleteFailed: '刪除失敗',
            enableSuccess: '啟用成功',
            enableFailed: '啟用失敗',
            disableSuccess: '停用成功',
            disableFailed: '停用失敗',
            permissionDenied: '無權限操作該技能',
            updateFileFailed: '儲存檔案失敗',
            createDirectorySuccess: '目錄建立成功',
            createDirectoryFailed: '目錄建立失敗',
            createFileSuccess: '檔案建立成功',
            createFileFailed: '檔案建立失敗',
            fileExists: '同名檔案已存在',
            renameSuccess: '重新命名成功',
            renameFailed: '重新命名失敗',
            deleteFileSuccess: '檔案已刪除',
            deleteFileFailed: '刪除檔案失敗',
            emptyFolderNotDeletable: '空目錄暫不支援刪除',
            workspaceInitFailed: 'AI 工作區初始化失敗，對話功能暫不可用',
        },
    },
};
